// extracted by mini-css-extract-plugin
export default {"examplesNavList":"Example_examplesNavList__1OTkZ","example":"Example_example__cpq1n","exampleText":"Example_exampleText__5y15K"};